import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CountrycurrencypageService } from '../countrycurrencypage.service';
import { HttpClient } from '@angular/common/http';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-country-currency-exchange-rate',
  templateUrl: './country-currency-exchange-rate.component.html',
  styleUrls: ['./country-currency-exchange-rate.component.scss'],
  imports: [CommonModule],
})
export class CountryCurrencyExchangeRateComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  constructor(
    private http: HttpClient,
    private countryCurrencyPageService: CountrycurrencypageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.subscriptions = [];
    this.localCurrency = '';
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  pricingData: any;
  usdChange: any;
  euroChange: any;
  gbpChange: any;
  jpyChange: any;
  audChange: any;
  cadChange: any;
  cnyChange: any;
  usdBody: any;
  euroBody: any;
  gbpBody: any;
  jpyBody: any;
  audBody: any;
  cadBody: any;
  cnyBody: any;
  localCurrency: string = '';
  change: string = '0';

  ngOnInit(): void {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    this.countryCurrencyPageService.pricing$.subscribe(data => {
      if (data != null) {
        this.pricingData = {
          header: data.pricing?.fields?.title,
          header1: data.pricing?.fields?.pricingTable[0]?.fields?.text1,
          header2: data.pricing?.fields?.pricingTable[0]?.fields?.text2,
          header3: data.pricing?.fields?.pricingTable[0]?.fields?.text3,
          table: data.pricing?.fields?.pricingTable,
        };
        this.localCurrency = data.currency;
        this.usdBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'USD',
          },
        };
        this.euroBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'EUR',
          },
        };
        this.gbpBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'GBP',
          },
        };
        this.jpyBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'JPY',
          },
        };
        this.audBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'AUD',
          },
        };
        this.cadBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'CAD',
          },
        };
        this.cnyBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'CNY',
          },
        };
        this.http
          .post(environment.currencyAPI, this.usdBody)
          .subscribe(data => {
            if (data != null) {
              this.usdChange = data;
              this.usdChange.label = `${this.localCurrency} To USD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.euroBody)
          .subscribe(data => {
            if (data != null) {
              this.euroChange = data;
              this.euroChange.label = `${this.localCurrency} To EUR`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.gbpBody)
          .subscribe(data => {
            if (data != null) {
              this.gbpChange = data;
              this.gbpChange.label = `${this.localCurrency} To GBP`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.jpyBody)
          .subscribe(data => {
            if (data != null) {
              this.jpyChange = data;
              this.jpyChange.label = `${this.localCurrency} To JPY`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.audBody)
          .subscribe(data => {
            if (data != null) {
              this.audChange = data;
              this.audChange.label = `${this.localCurrency} To AUD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.cadBody)
          .subscribe(data => {
            if (data != null) {
              this.cadChange = data;
              this.cadChange.label = `${this.localCurrency} To CAD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.cnyBody)
          .subscribe(data => {
            if (data != null) {
              this.cnyChange = data;
              this.cnyChange.label = `${this.localCurrency} To CNY`;
            }
          });
      }
    });
  }
  ngOnChanges(): void {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    const data = this.pageData;
      if (data != null && data.pricing?.fields) {
        this.pricingData = {
          header: data.pricing?.fields?.title || '',
          header1: data.pricing?.fields?.pricingTable?.[0]?.fields?.text1 || '',
          header2: data.pricing?.fields?.pricingTable?.[0]?.fields?.text2 || '',
          header3: data.pricing?.fields?.pricingTable?.[0]?.fields?.text3 || '',
          table: data.pricing?.fields?.pricingTable || [],
        };
        this.localCurrency = data.currency || '';
        this.usdBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'USD',
          },
        };
        this.euroBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'EUR',
          },
        };
        this.gbpBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'GBP',
          },
        };
        this.jpyBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'JPY',
          },
        };
        this.audBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'AUD',
          },
        };
        this.cadBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'CAD',
          },
        };
        this.cnyBody = {
          currencyFrom: {
            label: this.localCurrency,
          },
          currencyTo: {
            label: 'CNY',
          },
        };
        this.http
          .post(environment.currencyAPI, this.usdBody)
          .subscribe(data => {
            if (data != null) {
              this.usdChange = data;
              this.usdChange.label = `${this.localCurrency} To USD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.euroBody)
          .subscribe(data => {
            if (data != null) {
              this.euroChange = data;
              this.euroChange.label = `${this.localCurrency} To EUR`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.gbpBody)
          .subscribe(data => {
            if (data != null) {
              this.gbpChange = data;
              this.gbpChange.label = `${this.localCurrency} To GBP`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.jpyBody)
          .subscribe(data => {
            if (data != null) {
              this.jpyChange = data;
              this.jpyChange.label = `${this.localCurrency} To JPY`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.audBody)
          .subscribe(data => {
            if (data != null) {
              this.audChange = data;
              this.audChange.label = `${this.localCurrency} To AUD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.cadBody)
          .subscribe(data => {
            if (data != null) {
              this.cadChange = data;
              this.cadChange.label = `${this.localCurrency} To CAD`;
            }
          });
        this.http
          .post(environment.currencyAPI, this.cnyBody)
          .subscribe(data => {
            if (data != null) {
              this.cnyChange = data;
              this.cnyChange.label = `${this.localCurrency} To CNY`;
            }
          });
      }
  }

  invertRate(e: any) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    if (e.target.checked == true) {
      this.usdBody = {
        currencyFrom: {
          label: 'USD',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.euroBody = {
        currencyFrom: {
          label: 'EUR',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.gbpBody = {
        currencyFrom: {
          label: 'GBP',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.jpyBody = {
        currencyFrom: {
          label: 'JPY',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.audBody = {
        currencyFrom: {
          label: 'AUD',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.cadBody = {
        currencyFrom: {
          label: 'CAD',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.cnyBody = {
        currencyFrom: {
          label: 'CNY',
        },
        currencyTo: {
          label: this.localCurrency,
        },
      };
      this.http.post(environment.currencyAPI, this.usdBody).subscribe(data => {
        if (data != null) {
          this.usdChange = data;
          this.usdChange.label = `USD To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.euroBody).subscribe(data => {
        if (data != null) {
          this.euroChange = data;
          this.euroChange.label = `EUR To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.gbpBody).subscribe(data => {
        if (data != null) {
          this.gbpChange = data;
          this.gbpChange.label = `GBP To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.jpyBody).subscribe(data => {
        if (data != null) {
          this.jpyChange = data;
          this.jpyChange.label = `JPY To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.audBody).subscribe(data => {
        if (data != null) {
          this.audChange = data;
          this.audChange.label = `AUD To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.cadBody).subscribe(data => {
        if (data != null) {
          this.cadChange = data;
          this.cadChange.label = `CAD To ${this.localCurrency}`;
        }
      });
      this.http.post(environment.currencyAPI, this.cnyBody).subscribe(data => {
        if (data != null) {
          this.cnyChange = data;
          this.cnyChange.label = `CNY To ${this.localCurrency}`;
        }
      });
    } else {
      this.usdBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'USD',
        },
      };
      this.euroBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'EUR',
        },
      };
      this.gbpBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'GBP',
        },
      };
      this.jpyBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'JPY',
        },
      };
      this.audBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'AUD',
        },
      };
      this.cadBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'CAD',
        },
      };
      this.cnyBody = {
        currencyFrom: {
          label: this.localCurrency,
        },
        currencyTo: {
          label: 'CNY',
        },
      };
      this.http.post(environment.currencyAPI, this.usdBody).subscribe(data => {
        if (data != null) {
          this.usdChange = data;
          this.usdChange.label = `${this.localCurrency} To USD`;
        }
      });
      this.http.post(environment.currencyAPI, this.euroBody).subscribe(data => {
        if (data != null) {
          this.euroChange = data;
          this.euroChange.label = `${this.localCurrency} To EUR`;
        }
      });
      this.http.post(environment.currencyAPI, this.gbpBody).subscribe(data => {
        if (data != null) {
          this.gbpChange = data;
          this.gbpChange.label = `${this.localCurrency} To GBP`;
        }
      });
      this.http.post(environment.currencyAPI, this.jpyBody).subscribe(data => {
        if (data != null) {
          this.jpyChange = data;
          this.jpyChange.label = `${this.localCurrency} To JPY`;
        }
      });
      this.http.post(environment.currencyAPI, this.audBody).subscribe(data => {
        if (data != null) {
          this.audChange = data;
          this.audChange.label = `${this.localCurrency} To AUD`;
        }
      });
      this.http.post(environment.currencyAPI, this.cadBody).subscribe(data => {
        if (data != null) {
          this.cadChange = data;
          this.cadChange.label = `${this.localCurrency} To CAD`;
        }
      });
      this.http.post(environment.currencyAPI, this.cnyBody).subscribe(data => {
        if (data != null) {
          this.cnyChange = data;
          this.cnyChange.label = `${this.localCurrency} To CNY`;
        }
      });
    }
  }
}
